@import '../../global/variables/grid';

:host {
  display: block;

  .lgr-expandable-area {
    display: flex;
    justify-content: center;
    overflow: hidden;
    max-height: 100%;
    transition: max-height ease .3s;    

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--lgr-color-brand-primary);
      color: var(--lgr-color-neutral-high-pure);
      border: none;
      padding: 0;
      margin: 0 var(--lgr-spacing-nano);
      outline: unset;
      font-size: var(--lgr-font-size-xxl);
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      user-select: none;
      min-width: 48px;
      width: 48px;
      min-height: 48px;
      height: 48px;
      border-radius: 50%;
      transition: transform ease .3s;

      &-open {
        transform: rotate(180deg);
        transition: transform ease .3s;
      }
    }

    @media (min-width: $lgr-grid-md-break-point) {
      max-height: 100% !important;

      &-button {
        display: none;
      }
    }
  }
}